module.exports = __webpack_public_path__ + "img/video.d6de363f.svg";